import PropTypes from 'prop-types'

const Authorization = ({ children, hasRole }) => {
    return hasRole ? children : null
}

Authorization.propTypes = {
    requiredRole: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ]),
    hasRole: PropTypes.bool,
}

export default Authorization



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/Authorization.js